import events from "_src/engine/events";
import StackTrace from "stacktrace-js"

const isDev = process.env.NODE_ENV === "development";
let _logType;

export default {

  INDIGO:      "color: Indigo;",
  BLACK:       "color: black;",
  BLUE:        "color: DodgerBlue;",
  GREEN:       "color: ForestGreen;",
  RED:         "color: red;",
  YELLOW:      "color: yellow;",
  ORANGE:      "color: orange;",
  DARK_ORANGE: "color: darkorange;",

  LOADING_ERROR       : 0,
  STORAGE_ERROR       : 1,
  INITIALIZATION_ERROR: 2,
  DEVELOPERS_ERROR    : 3,
  API_ERROR           : 4,

  BROWSER_LOG         : 0,
  BACKEND_LOG         : 1,

  setLogType(logType) {
    _logType = logType;
  },

  log (message, color = this.BLACK, silent = false) {
    if (!silent) {
      if (_logType === this.BROWSER_LOG) {
        console.log("%c" + message, color);
      } else {
        console.log(message);
      }
    }

    events.emit("log", {
      payload: {message, stackTrace: StackTrace.getSync()},
    });
  },

  warn (message, color = this.DARK_ORANGE) {
    if (_logType === this.BROWSER_LOG) {
      console.warn("%cEngine warning: " + message, color);
    } else {
      console.warn("Engine warning: " + message);
    }

    events.emit("warn", {
      payload: {message, stackTrace: StackTrace.getSync()},
    });
  },

  error (type, message) {

    if (isDev) {
      console.error("Engine error: ", message);
    }

    events.emit("error", {
      type,
      payload: {message, stackTrace: StackTrace.getSync()},
    });

  }

}
